<template>
    <div class="uk-grid uk-grid-small">
        <div class="uk-width-2-10">
            <div
                class="nibnut-aspect-ratio-box nibnut-ratio-square"
            >
                <div>
                    <form-image-input
                        id="award-program-image_url"
                        name="image_url"
                        :value="term.image_url || ''"
                        placeholder="Logo (optional)"
                        :required="false"
                        :editable="true"
                        @click="select_file"
                        @upload="upload_file_list('image_url', $event)"
                        @remove="confirm_clear_file('image_url')"
                    />
                    <input
                        v-if="file_field_ready"
                        ref="file"
                        type="file"
                        :accept="upload_accepts()"
                        class="nibnut-proxied-control"
                        @change="set_upload_file"
                    >
                </div>
            </div>
        </div>
        <div class="uk-width-8-10">
            <div class="uk-grid uk-grid-small">
                <div class="uk-width-9-10">
                    <form-input
                        id="award-program-name"
                        name="name"
                        :value="term.name"
                        :editable="true"
                        :required="false"
                        class="uk-width-1-1"
                        @input="$emit('input', $event, 'name')"
                    />
                </div>
                <div class="uk-width-1-10 uk-text-right">
                    <base-button
                        color="danger"
                        @click.prevent.stop="$emit('remove', term)"
                    >
                        <open-icon glyph="trash" />
                    </base-button>
                </div>
            </div>
            <form-input
                id="award-program-url"
                name="url"
                :value="term.url"
                placeholder="(optional)"
                :editable="true"
                :required="false"
                class="uk-width-1-1"
                @input="$emit('input', $event, 'url')"
            >
                <template v-slot:label>URL</template>
            </form-input>
        </div>
    </div>
</template>

<script>
import handles_uploads from "../../mixins/HandlesUploads"

import FormInput from "../../ui/FormInput"
import FormImageInput from "../../ui/FormImageInput"
import BaseButton from "../../ui/BaseButton"
import OpenIcon from "../../ui/OpenIcon"

export default {
    name: "AwardTermEditor",
    mixins: [handles_uploads],
    components: {
        FormInput,
        FormImageInput,
        BaseButton,
        OpenIcon
    },
    methods: {
        upload_accepts (name, filename = null) {
            if(filename) return !!filename.match(/\.(png|jpe?g)$/i)
            return "image/jpeg,image/png,.jpg,.jpeg,.png"
        },
        select_file () {
            this.$refs.file.click()
        },
        set_upload_file (event) {
            this.upload_file_list("image_url", event.target.files)
            this.file_field_ready = false
            this.$nextTick(() => {
                this.file_field_ready = true
            })
        },
        upload_data (name) {
            return { entity: "term", id: this.term.id, data: { type: "image" } }
        }
    },
    props: {
        term: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            file_field_ready: true
        }
    }
}
</script>
